import StatusBadge from 'components/atoms/status-badge'
import { CURATION_STATUS } from 'domains/seller-product/constants'
import PropTypes from 'prop-types'
import React from 'react'

const proptypes = {
  curation_status: PropTypes.string
}

/**
 * To give nice look on Seller Product `confirmation_status`.
 * It maps `confirmation_status` to certain style and pass to `StatusBadge`.
 * @param {string} confirmation_status Seller Product confirmation status. available values
 * - `accepted`
 * - `rejected`
 * - `pending`
 * - `not_found`
 */
const SellerProductCurationStatusBadge = ({ curation_status }) => {

  const colorMap = {
    [CURATION_STATUS.ACCEPTED]  : 'success',
    [CURATION_STATUS.REJECTED]  : 'danger',
    [CURATION_STATUS.PENDING]   : 'warning',
    [CURATION_STATUS.NOT_FOUND] : 'info'
  }

  const color = colorMap[curation_status] || 'default'

  return <StatusBadge color={ color } label={ curation_status } />
}

SellerProductCurationStatusBadge.propTypes = proptypes

export default SellerProductCurationStatusBadge
